<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef> Matrícula </th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.matriculaAluno}} </td>
    </ng-container>

    <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef> Nome </th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.pessoaFisica?.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="dataEntrada">
        <th mat-header-cell *matHeaderCellDef> Data de admissão </th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.dataEntrada | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataSugestaoDesligamento">
        <th mat-header-cell *matHeaderCellDef> Data de sugestão de desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.dataSugestaoDesligamento | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataDesligamento">
        <th mat-header-cell *matHeaderCellDef> Data de desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.dataDesligamento | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="motivoDesligamento">
        <th mat-header-cell *matHeaderCellDef> Motivo do desligamento</th>
        <td mat-cell *matCellDef="let element"> {{element?.aluno?.motivoDesligamento.motivoDesligamento}} </td>
    </ng-container>
    
    <ng-container matColumnDef="stAtivo">
        <th mat-header-cell *matHeaderCellDef> Aluno Ativo </th>
        <td mat-cell *matCellDef="let element"> {{element.stAtivo ? 'Sim' : 'Não'}} </td>
    </ng-container> 

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar nova vulnerabilidade" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
